/**
 * Converter for Square service charge items <-> Paytronix service charge
 * items.
 */
export class ServiceChargeItemsConverter {
  /**
   * Converts Square service charge items to Paytronix service charge items.
   * @param serviceCharges Square service charge items.
   * @returns Paytronix service charge items.
   */
  static squareToPaytronix(serviceCharges) {
    return serviceCharges.map((serviceCharge) => {
      return {
        type: 'serviceChargeItem',
        itemId: serviceCharge.catalogObjectId ?? '',
        name: serviceCharge.name ?? '',
        isTaxable: !!serviceCharge.taxable,
        price: Number(serviceCharge.totalMoney?.amount ?? 0) / 100,
      };
    });
  }
}
